<template>
  <div>
    <v-row justify="center">
      <v-dialog
        class="modal_medium"
        v-model="visible"
        content-class=""
        persistent
      >
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">LECTURAS TOMADAS</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <v-alert
                        class="alert_custom"
                        v-if="msjError"
                        type="warning"
                        >
                        <div class="ctn_alert">
                            <v-btn @click="textInfo.flag = 0" color="#000" icon>
                            <v-icon>mdi-close</v-icon>
                            </v-btn>
                            <p class="ctn_alert_text">
                            {{ textInfo.text }}
                            </p>
                        </div>
                        </v-alert>
                    </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="6" md="6">
                    <v-combobox
                      ref="company"
                      v-model="form.company"
                      :items="itemsCompany"
                      :search-input.sync="searchCompany"
                      item-value="_id"
                      item-text="name"
                      label="Empresas"
                      placeholder="Digite el nombre de la empresa"
                      :disabled="isMaster == 0"
											@input="clearLists"
                      clearable
                    ></v-combobox>
                  </v-col>
                  <v-col cols="12" sm="6" md="6">
                    <v-combobox
                      ref="zone"
                      v-model="form.zone"
                      :items="itemsZone"
                      :search-input.sync="searchZone"
                      item-value="_id"
                      item-text="name"
                      label="Zona"
                      placeholder="selecciona la zona"
                      clearable
                    ></v-combobox>
                  </v-col>
									<v-col cols="12" sm="6" md="6">
                    <v-combobox
                      ref="cycle"
                      v-model="form.cycle"
                      :items="itemsCycle"
                      :search-input.sync="searchCycle"
                      item-value="_id"
                      item-text="name"
                      label="Ciclo"
                      placeholder="selecciona el ciclo"
                      clearable
                    ></v-combobox>
                  </v-col>
									<v-col cols="12" sm="6" md="6">
                    <v-combobox
                      ref="road"
                      v-model="form.road"
                      :items="itemsRoad"
                      :search-input.sync="searchRoad"
                      item-value="_id"
                      item-text="name"
                      label="Ruta"
                      placeholder="selecciona la ruta"
                      clearable
                    ></v-combobox>
                  </v-col>
									<v-col cols="12" sm="6" md="6">
                    <v-combobox
                      ref="social"
                      v-model="form.socialGroup"
                      :items="itemsSocial"
                      :search-input.sync="searchSocial"
                      item-value="_id"
                      item-text="name"
                      label="Estrato"
                      placeholder="selecciona el estrato"
                      clearable
                    ></v-combobox>
                  </v-col>
									<v-col cols="12" sm="6" md="6">
                    <v-combobox
                      ref="period"
                      v-model="form.period"
                      :items="itemsPeriod"
                      :search-input.sync="searchPeriod"
                      item-value="_id"
                      item-text="name"
                      label="Periodo"
                      placeholder="Selecciona el periodo"
                      clearable
                    ></v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click="this.closeModal" class="mr-2">Cerrar</v-btn>
                <v-btn
                  v-if="hideBtn == false"
                  @click="validate"
                  :loading="validating"
                  :disabled="validating"
                  large
                  color="primary"
                  >Validar
                </v-btn>
                <v-menu offset-y v-if="hideBtn == true">
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      dark
                      v-bind="attrs"
                      v-on="on"
                      large
                    >
                      DESCARGAR
                    </v-btn>
                  </template>
                  <v-list>
                    <v-list-item link>
                      <v-list-item-title>
                        <vue-excel-xlsx
                          :columns="columnas"
                          :data="response"
                          :file-name="nameReport"
                          :file-type="'xlsx'"
                          :sheet-name="'reporte'"
                          class="text-left w-100"
                        >
                          Excel
                        </vue-excel-xlsx>
                      </v-list-item-title>
                    </v-list-item>
                    <v-list-item link>
                      <v-list-item-title>
                        <download-csv
                          v-if="visibleBtn == true"
                          class="btn btn-default"
                          :data="response"
                          :name="`${nameReport}.csv`"
                        >
                          .CSV
                        </download-csv>
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import moment from "moment";
export default {
  name: "ReadsReportComp",
  components: {},
  props: ["visible"],
  data() {
    return {
      textInfo: { flag: 0, text: "No exisite ningun valor" },
      validating: false,
      form: {
        company: null,
        zone: null,
				cycle: null,
				road: null,
				socialGroup: null,
				period: null,
      },

      itemsCompany: [],
      searchCompany: null,
      itemsZone: [],
      searchZone: null,
			itemsCycle: [],
      searchCycle: null,
			itemsRoad: [],
      searchRoad: null,
			itemsSocial: [],
      searchSocial: null,
			itemsPeriod: [],
      searchPeriod: null,
      response: [],
      valid: true,
      visibleBtn: false,
      hideBtn: false,
      serviceRule: [(v) => !!v || "El campo es requerido"],
      nameRules: [(v) => !!v || "El campo es requerido"],
      fieldRules: [(v) => !!v || "El campo es requerido"],

      columnas: [
        {
          label: "Idx",
          field: "IDX",
        },
        {
          label: "NUI",
          field: "NUI",
        },
        {
          label: "Cód.Interno",
          field: "CodInterno",
        },
        {
          label: "Nombre",
          field: "Nombre",
        },
        {
          label: "Tipo Dispositivo",
          field: "Tipo",
        },
        {
          label: "Perfil",
          field: "Perfil",
        },
        {
          label: "Zona",
          field: "Zona",
        },
        {
          label: "Ciclo",
          field: "Ciclo",
        },
        {
          label: "Ruta",
          field: "Ruta",
        },
        {
          label: "Estrato",
          field: "Estrato",
        },
        {
          label: "Periodo",
          field: "Periodo",
        },
        {
          label: "Fecha Inicial",
          field: "Fecha Inicial",
        },
        {
          label: "Lectura Inicial",
          field: "Lectura Inicial",
        },
        {
          label: "Unidad L. Inicial",
          field: "Unidad L Inicial",
        },
        {
          label: "Fecha Final",
          field: "Fecha Final",
        },
        {
          label: "Lectura Final",
          field: "Lectura Final",
        },
        {
          label: "Unidad L. Final",
          field: "Unidad L Final",
        },
        {
          label: "Consumo",
          field: "Consumo",
        },
        {
          label: "Unidad Consumo",
          field: "Unidad Consumo",
        },
        {
          label: "Días",
          field: "Dias",
        },
        {
          label: "Fecha de ejecución",
          field: "Fecha de ejecucion",
        },
      ],
    };
  },
  async mounted() {
    document.addEventListener("keydown", (e) => {
      if (e.key === "Escape") {
        if(this.$refs.form) {
          this.$refs.form.reset();
        }
        this.$emit("close");
      }
    });
		this.fillLists();
  },

  updated() {
    if(this.isMaster == 0) {
      this.form.company = this.itemsCompany[0];
    }
  },

  watch: {
    searchCompany: {
      handler(val) {
        if(val != null && val.length > 1) this.getJsonCompany();
      },
      deep: true,
    },
    searchZone: {
      handler(val) {
        if(val != null && val.length > 1)  this.getJsonZone();
      },
      deep: true,
    },
		searchCycle: {
      handler(val) {
        if(val != null && val.length > 1)  this.getJsonCycle();
      },
      deep: true,
    },
		searchRoad: {
      handler(val) {
        if(val != null && val.length > 1)  this.getJsonRoad();
      },
      deep: true,
    },
		searchSocial: {
      handler(val) {
        if(val != null && val.length > 1) this.getJsonSocial();
      },
      deep: true,
    },
		searchPeriod: {
      handler(val) {
        if(val != null && val.length > 1)  this.getJsonPeriod();
      },
      deep: true,
    },
  },
  methods: {
    ...mapActions([
      "alertSnackbar",
      "exportReportReads",
    ]),

		clearLists() {
      this.$refs.zone.reset();
      this.$refs.cycle.reset();
      this.$refs.road.reset();
      this.$refs.social.reset();
      this.$refs.period.reset();
      this.fillLists();
		},

		async fillLists() {
			this.getJsonCompany();
			this.getJsonZone();
			this.getJsonCycle();
			this.getJsonRoad();
			this.getJsonSocial();
			this.getJsonPeriod();
		},

    async getJsonCompany() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let search = this.searchCompany != null ? this.searchCompany : '';
          axios
            .get(
              `company/list?page=1&search=${search}`,
              { headers: headerToken }
            )
            .then((res) => {
							this.itemsCompany = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },

    async getJsonZone() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let idCompany = this.form.company != null ? this.form.company._id : null;
          let url = `zone/list?page=1&company=${idCompany}`;
          if(this.searchZone != null) url += `&search=${this.searchZone}`;

          axios.get(url,
              { headers: headerToken }
            )
            .then((res) => {
							this.itemsZone = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },

		async getJsonCycle() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let idCompany = this.form.company != null ? this.form.company._id : null;
          let url = `cycle/list?page=1&company=${idCompany}`;
          if(this.searchCycle != null) url += `&search=${this.searchCycle}`;

          axios.get( url, 
              {
                headers: headerToken,
              }
            )
            .then((res) => {
							this.itemsCycle = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },

		async getJsonRoad() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let idCompany = this.form.company != null ? this.form.company._id : null;
          let url = `road/list?page=1&company=${idCompany}`;
          if(this.searchRoad != null) url += `&search=${this.searchRoad}`;

          axios.get(url,
              { headers: headerToken }
            )
            .then((res) => {
							this.itemsRoad = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },

		async getJsonSocial() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let idCompany = this.form.company != null ? this.form.company._id : null;
          let url = `socialgroup/list?page=1&company=${idCompany}`;
          if(this.searchSocial != null) url += `&search=${this.searchSocial}`;

          axios.get(url,
              { headers: headerToken }
            )
            .then((res) => {
							this.itemsSocial = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
        });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },

		async getJsonPeriod() {
      try {
        return new Promise((resolve, reject) => {
          let headerToken = { token: this.$store.state.token };
          let idCompany = this.form.company != null ? this.form.company._id : null;
          let url = 'period/list?page=1&onlyActive=true';
          if(this.searchPeriod != null) url += `&search=${this.searchPeriod}`;
          if(idCompany != null) url += `&company=${idCompany}`;

          axios.get(url,
              { headers: headerToken }
            )
            .then((res) => {
							this.itemsPeriod = res.data.docs;
              resolve(res.data);
            })
            .catch((error) => {
              reject(error.response.status);
            });
          });
      } catch (error) {
        throw new Error(error.response.data);
      }
    },

    closeModal() {
      this.form = {
        company: null,
        zone: null,
				cycle: null,
				road: null,
				socialGroup: null,
				period: null,
      };
      this.visibleBtn = false;
      this.hideBtn = false;
      this.response = [];
      this.textInfo = {
        flag: 0,
      };
      this.show = false;
    },

    async validate() {
      this.validating = true;
      this.response = await this.exportReportReads({
        company: this.form.company,
        zone: this.form.zone,
        cycle: this.form.cycle,
        road: this.form.road,
        socialgroup: this.form.socialGroup,
        period: this.form.period,
      });
      this.validating = false;
      if (this.$refs.form.validate() && this.response.length > 0) {
        this.visibleBtn = true;
        this.hideBtn = true;
      } else {
        this.visibleBtn = false;
        this.textInfo = {
          flag: 1,
          text: "No se encontró ninguna información con los parámetros establecidos",
        };
      }
    },

    async registerForm() {
      try {
        if (this.response.length > 0) {
          this.textInfo = {
            flag: 2,
          };
          this.closeModal();
          this.$root.$emit("reload"); // parametro update tabla
          this.alertSnackbar({
            snackbar: true,
            text: "Se genero un reporte de un dispositivo.",
          });
        } else {
          this.textInfo = {
            flag: 1,
            text: "No se encontró ninguna información con los parámetros establecidos",
          };
        }
      } catch (error) {
        this.alertSnackbar({
          snackbar: 1,
          text: "ocurrio un error con el servidor.",
        });
      }
    },
  },
  computed: {
    ...mapGetters([
      'isMaster'
    ]),

    nameReport() {
      let date = new Date();
      let formattedDate = moment(date).format('YYYYMMDD_h:mm:ss');
      return `Reporte_lecturas_${formattedDate}`;
    },

    zoneSelect() {
      let filt = this.itemsZone
        .map((item) => {
          if (this.data.company != null) {
            if (typeof this.data.company != "object") {
              if (item.company._id === this.data.company) {
                return item;
              }
            } else {
              if (item.company._id === this.data.company._id) {
                return item;
              }
            }
          } else {
            return null;
          }
        })
        .filter((item) => {
          return item;
        });
      return filt;
    },

    msjError() {
      if (this.textInfo.flag != 0) {
        return this.textInfo;
      } else {
        return null;
      }
    },
    show: {
      get() {
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$emit("close");
        }
      },
    },
  },
};
</script>
<style lang="scss" scope>
@import "../../assets/scss/base.scss";
.alert_custom {
  position: relative;
  .v-alert__icon.v-icon {
    background: #000;
  }
  .ctn_alert {
    button {
      position: absolute;
      right: 10px;
    }
    p {
      color: #000;
      padding-right: 20px;
      margin: 0;
    }
  }
}
.ctn_btn_shop {
  display: flex;
  flex-direction: row;
}
.colm_custom {
  &.show {
    display: block;
  }
  &.hide {
    display: none;
  }
}
</style>
